// Scripts
import Vue from 'vue';
import VueRouter from 'vue-router';
var VueTouch = require('vue-touch');
import Home from './pages/homepage.vue';
import Contact from './pages/contact.vue';
import About from './pages/about.vue';
import Portfolio from './pages/portfolio.vue';
import Item from './components/item.vue';
import PageFooter from './components/footer.vue';

Vue.use(VueRouter);
Vue.use(VueTouch, {name: 'v-touch'});

const router = new VueRouter({
  mode: 'history',
  routes: [
    { path: '', component: Home },
    { path: '/contact', component: Contact },
    { path: '/about', component: About },
    { path: '/portfolio', component: Portfolio },
    { path: '/portfolio/:id', component: Item }
  ]
});

new Vue({
  components: {PageFooter},
  el: '#site',
  router
});



// WEBPACK FOOTER //
// ./src/js/main.js